/* istanbul ignore file */
import { gql } from '@ori/fetching';
import { labels } from './labels';
export const shades = gql`
  ${labels}
  fragment ShadePickerShade on Product {
    shadeName
    hexColors
    colorImageUrl
    productCode
    formattedPrice {
      price {
        priceAfterImmediateDiscount
        currentPrice
      }
    }
    labels {
      ...ProductLabels
    }
  }
`;
//# sourceMappingURL=shades.js.map